import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/constants/queryKeys";
import { services } from "@/services/registry";
export const useCustomers = (enabled = true)=>{
    return useQuery({
        queryKey: queryKeys.customers.all(),
        queryFn: ()=>services.customersService.getAllCustomers(),
        enabled
    });
};
